import { render, staticRenderFns } from "./previewType.vue?vue&type=template&id=d562e4cc&scoped=true&"
import script from "./previewType.vue?vue&type=script&lang=js&"
export * from "./previewType.vue?vue&type=script&lang=js&"
import style0 from "./previewType.vue?vue&type=style&index=0&id=d562e4cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d562e4cc",
  null
  
)

export default component.exports